const outcomes = [
  { metric: "$2.4M", label: "Annual ROI identified", desc: "Average opportunity surfaced in the first assessment cycle." },
  { metric: "38%", label: "Cycle time reduction", desc: "Achieved in 90 days from a single prioritized workflow." },
  { metric: "4x", label: "Faster decision velocity", desc: "From AI conversation to validated, sequenced execution." },
];

const Outcomes = () => {
  return (
    <section className="py-12 lg:py-14">
      <div className="container-tight">
        <div className="max-w-3xl">
          <span className="eyebrow">Outcomes</span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            The kind of clarity that moves boardrooms.
          </h2>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {outcomes.map((o) => (
            <div key={o.label} className="group relative overflow-hidden rounded-2xl border border-border bg-card p-8 shadow-soft transition-all hover:shadow-card">
              <div className="absolute right-0 top-0 h-24 w-24 rounded-full bg-signal-soft opacity-0 blur-2xl transition-opacity group-hover:opacity-100" />
              <div className="relative">
                <p className="flex h-[5.25rem] items-end whitespace-nowrap font-serif text-6xl leading-none tracking-tight tabular-nums lining-nums text-foreground">{o.metric}</p>
                <p className="mt-3 text-base font-semibold text-foreground">{o.label}</p>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{o.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 max-w-2xl text-base text-muted-foreground">
          Most organizations have multiple such opportunities, the challenge is identifying them early, <span className="font-medium text-foreground">without heavy upfront investment</span>.
        </p>
      </div>
    </section>
  );
};

export default Outcomes;
